import gsap from "gsap";

export default class LanguageSwitcher {
	constructor(el) {
		this.el = el;
		this.lang = null;
		this.init();
	}

	init() {
		this.toggleBtn = this.el.querySelector("[js-lang-toggle-btn]");
		this.dropdown = this.el.querySelector("[js-lang-dropdown]");
		this.selectEl = this.el.querySelector("select");
		this.lang = this.selectEl.value;
		this.toggleBtn.innerHTML = this.lang === "fr-CH" ? "FR" : "EN";
		this.langBtns = this.el.querySelectorAll("[data-lang]");
		this.langBtns.forEach((btn) => {
			if (btn.dataset.lang === this.lang) {
				btn.classList.add("--active");
			}
		});
		this.createEventListeners();
	}

	createEventListeners() {
		this.toggleBtn.addEventListener("click", this.toggleDropdown);
		this.langBtns.forEach((btn) => {
			btn.addEventListener("click", () => {
				this.switchLanguage(btn);
			});
		});
	}

	toggleDropdown = () => {
		const isOpen = this.toggleBtn.getAttribute("aria-expanded") === "true";

		isOpen ? this.closeDropdown() : this.openDropdown();
	};

	openDropdown() {
		this.disableBtn(this.toggleBtn);
		this.toggleBtn.setAttribute("aria-expanded", true);
		gsap.set(this.dropdown, { css: { display: "block" } });
		gsap.to(this.dropdown, {
			opacity: 1,
			duration: 0.3,
			ease: "power3.out",
		});
	}

	closeDropdown() {
		this.disableBtn(this.toggleBtn);
		this.toggleBtn.setAttribute("aria-expanded", false);
		gsap.to(this.dropdown, {
			opacity: 0,
			duration: 0.3,
			ease: "power3.out",
		});
		gsap.set(this.dropdown, { css: { display: "none" }, delay: 0.3 });
	}

	disableBtn(btn) {
		btn.disabled = true;
		setTimeout(() => {
			btn.disabled = false;
		}, 260);
	}

	switchLanguage(btn) {
		this.selectEl.value = btn.dataset.lang;
		this.toggleBtn.innerHTML = btn.dataset.label;
		this.langBtns.forEach((btn) => btn.classList.remove("--active"));
		btn.classList.add("--active");
		this.closeDropdown();
	}
}
